import { SYNC_OVERLAYS } from 'actions/Types';
import { withCurrentParams, mapSignedUrlsToSources } from 'actions/utils';

export default () => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: SYNC_OVERLAYS,
      request: async apiClient => {
        const broadcast = await apiClient.broadcast.get(
          teamId,
          eventId,
          broadcastId
        );
        const { overlays } = broadcast;
        const mappedOverlays = mapSignedUrlsToSources(
          overlays,
          apiClient,
          teamId,
          eventId
        );
        return {
          overlays: await mappedOverlays
        };
      }
    };
    dispatch(action);
  });
};
